import React from "react";

const LiveCasinoIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
			{...props}>
			<g clipPath="url(#clip0_1962_539637)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M3.22391 13.8953C2.91749 14.083 2.49635 14.0143 2.28617 13.7457C1.1344 12.283 0.5 10.3607 0.5 8.33502C0.5 6.30796 1.1344 4.38631 2.28617 2.92364C2.41166 2.76385 2.61877 2.66797 2.83973 2.66797C2.97677 2.66797 3.10919 2.70469 3.22314 2.77405C3.52802 2.96241 3.60347 3.333 3.39252 3.60228C2.39627 4.86842 1.84733 6.54936 1.84733 8.33502C1.84732 10.12 2.39627 11.8009 3.39252 13.0671C3.60347 13.3357 3.52802 13.7069 3.22391 13.8953ZM5.54531 11.9715C5.23812 12.1585 4.81853 12.0912 4.6068 11.8219C3.86308 10.8768 3.45272 9.63849 3.45272 8.33495C3.45272 7.0314 3.86308 5.79314 4.60681 4.84795C4.73307 4.68815 4.9394 4.59228 5.16036 4.59228C5.29741 4.59228 5.4306 4.629 5.54454 4.69835C5.84943 4.88671 5.92488 5.25799 5.71315 5.52658C5.12418 6.27525 4.80005 7.2728 4.80005 8.33495C4.80005 9.39777 5.12418 10.3946 5.71315 11.1433C5.92487 11.4119 5.84942 11.7832 5.54531 11.9715ZM13.7761 2.77397C14.0825 2.58629 14.5036 2.65497 14.7138 2.92357C15.8656 4.38623 16.5 6.30856 16.5 8.33426C16.5 10.3613 15.8656 12.283 14.7138 13.7456C14.5883 13.9054 14.3812 14.0013 14.1603 14.0013C14.0232 14.0013 13.8908 13.9646 13.7769 13.8952C13.472 13.7069 13.3965 13.3363 13.6075 13.067C14.6037 11.8009 15.1527 10.1199 15.1527 8.33426C15.1527 6.54928 14.6037 4.86834 13.6075 3.6022C13.3965 3.3336 13.472 2.96233 13.7761 2.77397ZM11.4547 4.69773C11.7619 4.51073 12.1815 4.57805 12.3932 4.84733C13.1369 5.79252 13.5473 7.03078 13.5473 8.33433C13.5473 9.63787 13.1369 10.8761 12.3932 11.8213C12.2669 11.9811 12.0606 12.077 11.8396 12.077C11.7026 12.077 11.5694 12.0403 11.4555 11.9709C11.1506 11.7826 11.0751 11.4113 11.2868 11.1427C11.8758 10.394 12.2 9.39647 12.2 8.33433C12.2 7.2715 11.8758 6.27463 11.2868 5.52596C11.0751 5.25736 11.1506 4.88609 11.4547 4.69773ZM8.50102 10.3197C9.65361 10.3197 10.588 9.38539 10.588 8.23279C10.588 7.0802 9.65361 6.14583 8.50102 6.14583C7.34842 6.14583 6.41406 7.0802 6.41406 8.23279C6.41406 9.38539 7.34842 10.3197 8.50102 10.3197Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1962_539637">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default LiveCasinoIcon;
